import { render } from "./PersonalizedPopupProductCard.vue?vue&type=template&id=6447be8a"
import script from "./PersonalizedPopupProductCard.vue?vue&type=script&lang=js"
export * from "./PersonalizedPopupProductCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__